module.exports = __webpack_public_path__ + "static/media/nairaPhone.61731568.png";